import axios from 'axios';
import { PreviousDocumentsAddFormModel, PreviousDocumentsPage } from 'app/edozvola/cases/previous-documents/model/previous-documents.model';

export const fetchPreviousDocument = async ({ uuid, webId }): Promise<PreviousDocumentsAddFormModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/previous-document/${uuid}/${webId}`)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const deletePreviousDocument = async (uuid, webId): Promise<PreviousDocumentsAddFormModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/cases/previous-document/${uuid}/${webId}`)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const savePreviousDocument = async (
  uuid: string,
  previousDocument: PreviousDocumentsAddFormModel,
): Promise<PreviousDocumentsAddFormModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/previous-document/${uuid}`, previousDocument)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const fetchPreviousDocuments = async ({ signal, pagination, uuid }): Promise<PreviousDocumentsPage> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(
        `api/cases/previous-document/${uuid}??page=${pagination.page}&size=${pagination.size}&column=${pagination.column}&direction=${pagination.direction}`,
        {
          signal: signal,
        },
      )
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.error);
      });
  });
};

export const fetchSavedPreviousDocument = async ({ uuid, idCasePreviousDocumentMap }): Promise<PreviousDocumentsAddFormModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/previous-document/saved/${uuid}/${idCasePreviousDocumentMap}`)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

